import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Store } from '@sama/app-state';
import { DirectiveSuperclass } from '@sama/ng-core';

@Component({
  selector: 'h3-view-settings-opacity-slider',
  templateUrl: './view-settings-opacity-slider.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ViewSettingsOpacitySliderComponent extends DirectiveSuperclass {
  @Input({ required: true }) defaultLayerOpacity!: number;
  @Input({ required: true }) layerOpacityStore!: Store<number>;

  eventSettingName = 'opacity';
}
